module.exports = __webpack_public_path__ + "static/media/lendf.ed12401b.svg";